module.exports = __webpack_public_path__ + "static/media/ss4_preview.0174d070.jpg";